import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Order} from '../models/order';
import {LoadOrderSuccessAction, orderActionTypes, OrderClearAction} from '../actions/order-load';
import {orderPatchActionTypes, PatchOrdersSuccessAction} from '../actions/order-patch';

export interface OrderState {
  order: Order;
}

const initialState: OrderState = {
  order: undefined
};

export function OrderReducer(state: OrderState = initialState, action: Action): OrderState {
  switch (action.type) {
    case orderActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case orderActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case orderActionTypes.CLEAR:
      return handleLoadClearActions(state, action);
    case orderPatchActionTypes.PATCH_SUCCESS:
      return handlePatchActions(state, action);
    default:
      return state;
  }
}

function handlePatchActions(state: OrderState, action: PatchOrdersSuccessAction): OrderState {
  if (action.payload && action.payload.uuid) {
    return {...state, order: action.payload};
  }

  return state;

}

function handleLoadSuccessAction(state: OrderState, action: LoadOrderSuccessAction): OrderState {
  const newState: OrderState = {
    order: action.payload
  };
  return newState;
}

function handleLoadClearActions(state: OrderState, action: OrderClearAction): OrderState {
  const newState: OrderState = {
    order: undefined
  };
  return newState;
}

function handleLoadErrorActions(state: OrderState): OrderState {
  return state;
}


export const orderSelectors = {
  order: (state: OrderState) => _.get(state, 'order', null)
};
